import React from 'react'
import './AminMenuDataCard.scss'
import AminMenuDataCardText from './AminMenuDataCardText/AminMenuDataCardText'
const AminMenuDataCard = ({clientsData, location, tarifName}) => {
   const langGlobal = localStorage.getItem('lang')
   
  return (
    <div className='aminMenuDataCard_block' style={{height: location === '/notNetwork' && '100%'}}>
      <AminMenuDataCardText title={location === '/notNetwork' && langGlobal === 'TJ' ? 'Ном' : 'Имя'} subtitle={clientsData?.fio}/>
      <AminMenuDataCardText title={location === '/notNetwork' && langGlobal === 'TJ' ? 'Суратхисоб' : 'Лицевой счет'} subtitle={clientsData?.id}/>
      <AminMenuDataCardText title={location === '/notNetwork' && langGlobal === 'TJ' ? 'Рақами телефон' :'Номер телефона'} subtitle={clientsData?.phone_number}/>
      {
       location === '/notNetwork' &&
      <AminMenuDataCardText title={location === '/notNetwork' && langGlobal === 'TJ' ? 'Тарофа' :'Тариф:'} subtitle={tarifName}/>
      }
    </div>
  )
}

export default AminMenuDataCard
